import { createReducer, on } from "@ngrx/store";
import { LoginPageActions } from "src/shared/actions-index";
import { LoginPageApiActions } from "src/shared/actions-index";
import { Login } from "../models/login.model";

export interface State {
  loginData: Login;
  loggedUserId: string | null;
  token: string | null;
  mfaToken: string | null;
  error: string | null;
  loading: boolean;
}

export const initialState: State = {
  loginData: new Login(null, null),
  loggedUserId: null,
  token: null,
  mfaToken: null,
  error: null,
  loading: false
}

export const reducer = createReducer(
  initialState,
  on(LoginPageActions.enter, (state) => {
    return {
      ...state,
      loginData: new Login(null, null),
      loggedUserId: null,
      token: null,
      mfaToken: null,
      loading: false
    }
  }),
  on(LoginPageActions.login, (state, { login }) => {
    return {
      ...state,
      loginData: login,
      loggedUserId: null,
      token: null,
      mfaToken: null,
      error: null,
      loading: true
    }
  }),
  // Usuário com 2FA: guarda o token intermediário e libera o campo do código.
  // loginData (com a senha) permanece apenas em memória, para concluir o login depois.
  on(LoginPageApiActions.mfaRequired, (state, { mfaToken }) => {
    return {
      ...state,
      mfaToken: mfaToken,
      error: null,
      loading: false
    }
  }),
  on(LoginPageActions.loginMfa, (state) => {
    return {
      ...state,
      error: null,
      loading: true
    }
  }),
  // Voltar para usuário e senha: descarta token intermediário e senha
  on(LoginPageActions.mfaCancel, (state) => {
    return {
      ...state,
      loginData: new Login(null, null),
      mfaToken: null,
      error: null,
      loading: false
    }
  }),
  on(LoginPageApiActions.mfaTokenExpired, (state) => {
    return {
      ...state,
      loginData: new Login(null, null),
      mfaToken: null,
      loading: false
    }
  }),
  on(LoginPageApiActions.loginSuccess, (state, { loggedUserId, token }) => {
    return {
      ...state,
      loginData: new Login(null, null),
      loggedUserId: loggedUserId,
      token: token,
      mfaToken: null,
      error: null,
      loading: false
    }
  }),
  on(LoginPageApiActions.loginFailed, (state, { error }) => {
    return {
      ...state,
      error: error,
      loggedUserId: null,
      token: null,
      loading: false
    }
  }),
)

export const getLoginData = (state: State) => state.loginData;
export const getLoggedUserId = (state: State) => state.loggedUserId;
export const getToken = (state: State) => state.token;
export const getMfaToken = (state: State) => state.mfaToken;
export const getError = (state: State) => state.error;
export const getLoading = (state: State) => state.loading;

